import { t } from './index';

// Exact, product-owned strings from connector seed schemas, reports/seed.py,
// AppMetrica's field catalog and Direct's stream catalog. Unknown text stays
// untouched. This dictionary must only be used for known platform metadata.
const METADATA_KEYS = {
  "PostgreSQL": "postgreSQL",
  "Connect to any PostgreSQL database (v9.4+).": "connectToAnyPostgreSQLDatabaseV94",
  "MySQL": "mySQL",
  "Connect to MySQL or MariaDB databases.": "connectToMySQLOrMariaDBDatabases",
  "Microsoft SQL Server": "microsoftSQLServer",
  "Connect to MS SQL Server or Azure SQL.": "connectToMSSQLServerOrAzureSQL",
  "MongoDB": "mongoDB",
  "Connect to MongoDB Atlas or self-hosted clusters.": "connectToMongoDBAtlasOrSelfHostedClusters",
  "Google BigQuery": "googleBigQuery",
  "Read tables or daily-sharded families (a GA4 export) with a window that prunes before it reads.": "readTablesOrDailyShardedFamiliesAGA4",
  "Snowflake": "snowflake",
  "Connect to Snowflake data warehouse.": "connectToSnowflakeDataWarehouse",
  "Shopify": "shopify",
  "Sync orders, products, customers, and more from Shopify.": "syncOrdersProductsCustomersAndMoreFromShopify",
  "Salesforce": "salesforce",
  "Extract CRM data from Salesforce.": "extractCRMDataFromSalesforce",
  "Google Analytics 4": "googleAnalytics4",
  "Pull GA4 events and conversions into your warehouse.": "pullGA4EventsAndConversionsIntoYourWarehouse",
  "HubSpot": "hubSpot",
  "Sync contacts, deals, companies, and activities from HubSpot.": "syncContactsDealsCompaniesAndActivitiesFromHubSpot",
  "Stripe": "stripe",
  "Sync charges, subscriptions, invoices, and customers from Stripe.": "syncChargesSubscriptionsInvoicesAndCustomersFromStripe",
  "Google Sheets": "googleSheets",
  "Use a Google Sheet as a data source.": "useAGoogleSheetAsADataSource",
  "S3 Files (CSV)": "s3FilesCSV",
  "CSV/TSV file drops in an S3-compatible bucket — one folder per source table.": "cSVTSVFileDropsInAnS3Compatible",
  "HTTP API": "hTTPAPI",
  "Generic REST API source with configurable auth.": "genericRESTAPISourceWithConfigurableAuth",
  "Amazon S3": "amazonS3",
  "Sync CSV/JSON/Parquet files from an S3 bucket.": "syncCSVJSONParquetFilesFromAnS3",
  "Apache Kafka": "apacheKafka",
  "Consume messages from Kafka topics.": "consumeMessagesFromKafkaTopics",
  "Host": "host",
  "Port": "port",
  "Database name": "databaseName",
  "Username": "username",
  "Password": "password",
  "Use SSL": "useSSL",
  "Database": "database",
  "Connection URI": "connectionURI",
  "mongodb+srv://user:pass@cluster.example.com": "mongodbSrvUserPassClusterExampleCom",
  "GCP project": "gCPProject",
  "Where the query runs — and the project billed for the bytes it scans.": "whereTheQueryRunsAndTheProjectBilled",
  "Service account JSON": "serviceAccountJSON",
  "Paste the full key file. Needs BigQuery Data Viewer on the dataset and Job User on the project.": "pasteTheFullKeyFileNeedsBigQueryData",
  "Dataset": "dataset",
  "For a GA4 export: analytics_<property id>.": "forAGA4ExportAnalyticsPropertyId",
  "Dataset project": "datasetProject",
  "Only when the tables live in another project than the one above — a dataset shared across the organisation, or a public one. Bytes are still billed to the project above. Leave empty for an export that lands in your own project.": "onlyWhenTheTablesLiveInAnotherProject",
  "Tables": "tables",
  "Comma-separated. A trailing * is a daily-sharded family: events_* covers events_20260101 and its siblings, and each load reads only the days it needs.": "commaSeparatedATrailingIsADailySharded",
  "Time column": "timeColumn",
  "Ordinary tables only: the DATE/DATETIME/TIMESTAMP column the loading window filters on. Sharded families ignore it — the shard is the day. Left empty, a plain table is reloaded whole every run.": "ordinaryTablesOnlyTheDATEDATETIMETIMESTAMPColumn",
  "Location": "location",
  "EU, US, europe-west3… Blank lets BigQuery decide.": "eUUSEuropeWest3BlankLetsBigQueryDecide",
  "Start date": "startDate",
  "YYYY-MM-DD — the earliest day to read when nothing has been loaded yet.": "yYYYMMDDTheEarliestDayToRead",
  "Lookback days": "lookbackDays",
  "Re-read this many days behind the last loaded one. 0 for a source that never changes a day once it is written; 3 for a GA4 export, which keeps adding late events to shards it has already closed. Required, and deliberately without a default: a number nobody chose either loses late rows or pays to re-read days that never change.": "reReadThisManyDaysBehindTheLast",
  "Byte ceiling per query": "byteCeilingPerQuery",
  "A query estimated above this is refused before it runs — the safety net for a window that fails to prune.": "aQueryEstimatedAboveThisIsRefusedBefore",
  "Account identifier": "accountIdentifier",
  "e.g. xy12345.us-east-1": "eGXy12345UsEast1",
  "Warehouse": "warehouse",
  "Schema": "schema",
  "Role": "role",
  "Optional Snowflake role": "optionalSnowflakeRole",
  "Shop subdomain": "shopSubdomain",
  "e.g. my-store (without .myshopify.com)": "eGMyStoreWithoutMyshopifyCom",
  "Access Token": "accessToken",
  "Security Token": "securityToken",
  "GA4 Property ID": "gA4PropertyID",
  "Numeric property ID, e.g. 123456789": "numericPropertyIDEG123456789",
  "Service Account JSON": "serviceAccountJSON2",
  "Paste the contents of your service account JSON key.": "pasteTheContentsOfYourServiceAccountJSON",
  "Private App Access Token": "privateAppAccessToken",
  "Secret API Key": "secretAPIKey",
  "Starts with sk_live_ or sk_test_": "startsWithSkLiveOrSkTest",
  "Spreadsheet ID": "spreadsheetID",
  "From the URL: .../spreadsheets/d/{ID}/...": "fromTheURLSpreadsheetsDID",
  "S3 endpoint": "s3Endpoint",
  "S3-compatible endpoint URL (leave empty for AWS). Cloud.ru and MinIO are path-style only — handled automatically.": "s3CompatibleEndpointURLLeaveEmptyForAWS",
  "Bucket": "bucket",
  "Region": "region",
  "Access key ID": "accessKeyID",
  "Read-only key for YOUR bucket. Cloud.ru uses the composite form tenant_id:key_id.": "readOnlyKeyForYOURBucketCloudRu",
  "Secret access key": "secretAccessKey",
  "Base URL": "baseURL",
  "e.g. https://api.example.com/v1": "eGHttpsApiExampleComV1",
  "API Key": "aPIKey",
  "Auth type": "authType",
  "Bucket name": "bucketName",
  "AWS Region": "aWSRegion",
  "e.g. us-east-1": "eGUsEast1",
  "Access Key ID": "accessKeyID2",
  "Secret Access Key": "secretAccessKey2",
  "Path prefix": "pathPrefix",
  "Optional folder prefix, e.g. data/exports/": "optionalFolderPrefixEGDataExports",
  "Bootstrap servers": "bootstrapServers",
  "host1:9092,host2:9092": "host19092Host29092",
  "Topic pattern": "topicPattern",
  "e.g. events-*": "eGEvents",
  "Consumer group ID": "consumerGroupID",
  "SASL username": "sASLUsername",
  "SASL password": "sASLPassword",
  "Client-Id": "clientId",
  "From the seller cabinet: Настройки → Seller API.": "fromTheSellerDashboardSettingsSellerAPI",
  "Api-Key": "apiKey",
  "Issue the key with the single role «Admin read only»: it reads everything this connector loads and can change nothing in the shop. A key with write roles still works, but every check warns about it. Ozon keys expire after 3 months — the connection goes offline when it does.": "issueTheKeyWithTheSingleRoleAdmin",
  "Lookback, days": "lookbackDays2",
  "Each run re-reads this many days behind the last one: posting statuses, returns and accruals change after the fact, and each re-read day is replaced whole. Blank = 30.": "eachRunReReadsThisManyDaysBehind",
  "Ozon": "ozon",
  "Ozon seller cabinet: FBO and FBS postings by product line, returns, accruals, the monthly realization report, balance and payouts, the sales funnel and search analytics, promotions, reviews and ratings, supplies, and daily snapshots of the catalog, prices and stocks.": "ozonSellerCabinetFBOAndFBSPostingsBy",
  "Client ID": "clientID",
  "Performance API service account, from the seller cabinet: Настройки → API-ключи → Performance API.": "performanceAPIServiceAccountFromTheSellerDashboard",
  "Client Secret": "clientSecret",
  "The service account's key. Ozon does not document a read-only level for it: the key can manage campaigns. The platform only reads statistics, campaigns and bids.": "theServiceAccountSKeyOzonDoesNot",
  "Each run re-reads this many days: Ozon keeps attributing orders to ads for days after the click. Blank = 7.": "eachRunReReadsThisManyDaysOzon",
  "Reports per run": "reportsPerRun",
  "Ozon builds statistics reports one at a time and rations them per day; a run stops cleanly after this many and the next one continues. Blank = 300.": "ozonBuildsStatisticsReportsOneAtATime",
  "Ozon Реклама": "ozonAdvertising",
  "Ozon advertising (Performance API): spend, views, clicks and orders per campaign, SKU and day; «Оплата за заказ» per order; external traffic by UTM; daily snapshots of campaigns, budgets and bids.": "ozonAdvertisingPerformanceAPISpendViewsClicksAnd",
  "User-Id": "userId",
  "Topvisor account login (sent as the 'User-Id' header).": "topvisorAccountLoginSentAsTheUserId",
  "API key": "aPIKey2",
  "From the Topvisor account settings.": "fromTheTopvisorAccountSettings",
  "Region indexes": "regionIndexes",
  "Comma-separated global Topvisor region indexes (1 = Москва), taken from the region picker in Topvisor. Not the project's row order. A region you omit produces no rows and no error, so the run log names any the project tracks but this list does not cover.": "commaSeparatedGlobalTopvisorRegionIndexes1Taken",
  "Project ids": "projectIds",
  "Comma-separated project ids. Blank = every project the key can see.": "commaSeparatedProjectIdsBlankEveryProjectThe",
  "Extra cell fields": "extraCellFields",
  "Comma-separated: relevant_url, snippet, visitors, … Blank = position only, which roughly halves the payload.": "commaSeparatedRelevantUrlSnippetVisitorsBlankPosition",
  "History from": "historyFrom",
  "Earliest check date to load. Blank = the project's whole history.": "earliestCheckDateToLoadBlankTheProject",
  "Topvisor": "topvisor",
  "Search-engine positions per keyword, region and check date, plus the keyword/group/region dimensions around them.": "searchEnginePositionsPerKeywordRegionAndCheck",
  "OAuth token": "oAuthToken",
  "Only without a connected Yandex account: a token with appmetrica:read obtained by hand, sent as 'Authorization: OAuth <token>'.": "onlyWithoutAConnectedYandexAccountAToken",
  "Application ID": "applicationID",
  "Numeric id of the app in AppMetrica. With a connected account it is picked from the account's apps.": "numericIdOfTheAppInAppMetricaWith",
  "Date dimension": "dateDimension",
  "Which time the loading window filters on: 'default' (the time on the device) or 'receive' (when the server received the event; catches late-arriving data).": "whichTimeTheLoadingWindowFiltersOnDefault",
  "Yandex AppMetrica": "yandexAppMetrica",
  "Raw events, installs, sessions, crashes and revenue from the Yandex AppMetrica Logs API.": "rawEventsInstallsSessionsCrashesAndRevenueFrom",
  "Data types": "dataTypes",
  "Data Stream data types to load; each must be exported in the app's Data Stream settings in AppMetrica. Every field of a type is loaded; fields the export does not include stay empty.": "dataStreamDataTypesToLoadEachMustBe",
  "App events": "appEvents",
  "App installations": "appInstallations",
  "Session ends": "sessionEnds",
  "Deeplink opens": "deeplinkOpens",
  "Delay, minutes": "delayMinutes",
  "Load only windows that closed at least this long ago (10–180, default 15): AppMetrica keeps appending to the newest windows.": "loadOnlyWindowsThatClosedAtLeastThis",
  "Yandex AppMetrica Data Stream": "yandexAppMetricaDataStream",
  "Raw events, installs, sessions, crashes and revenue from the Yandex AppMetrica Data Stream API, loaded hour by hour.": "rawEventsInstallsSessionsCrashesAndRevenueFrom2",
  "Only without a connected Yandex account: a token with direct:api obtained by hand.": "onlyWithoutAConnectedYandexAccountAToken2",
  "Client logins": "clientLogins",
  "An agency's clients to load, comma-separated. Blank = the connected account's own campaigns.": "anAgencySClientsToLoadCommaSeparated",
  "Streams": "streams",
  "Comma-separated streams. Blank is refused — object streams spend the advertiser's API points. campaign_stats is always loaded.": "commaSeparatedStreamsBlankIsRefusedObjectStreams",
  "Money with VAT": "moneyWithVAT",
  "Fixed once data is loaded: one value for the history.": "fixedOnceDataIsLoadedOneValueFor",
  "Attribution model": "attributionModel",
  "Extra goals": "extraGoals",
  "Metrica goal ids for goal_stats besides the campaigns' key goals, comma-separated.": "metricaGoalIdsForGoalStatsBesidesThe",
  "Each run re-reads this many days: Direct revises clicks and conversions keep arriving after the click. Blank = 30.": "eachRunReReadsThisManyDaysDirect",
  "API points ceiling, %": "aPIPointsCeiling",
  "The share of an advertiser's available API points one run may spend on objects. Blank = 50.": "theShareOfAnAdvertiserSAvailableAPI",
  "The first Moscow day a first load reads (YYYY-MM-DD). The pipeline's own window, when set, takes precedence.": "theFirstMoscowDayAFirstLoadReads",
  "Whose API points": "whoseAPIPoints",
  "An agency's clients: the client's points, the client's then the agency's, or the agency's.": "anAgencySClientsTheClientSPoints",
  "Yandex Direct": "yandexDirect",
  "Yandex Direct advertising: spend, clicks, conversions and revenue by campaign, ad group, ad, keyword, search query, placement, region and audience; daily snapshots of campaigns, ads, keywords and bids. An advertiser's account or an agency's clients.": "yandexDirectAdvertisingSpendClicksConversionsAndRevenue",
  "Only without a connected Yandex account: a token obtained by hand, sent as 'Authorization: OAuth <token>'.": "onlyWithoutAConnectedYandexAccountAToken3",
  "Counter ID": "counterID",
  "Yandex Metrica counter (tag) id. With a connected account it is picked from the account's counters.": "yandexMetricaCounterTagIdWithAConnected",
  "End date": "endDate",
  "Last day to sync. Defaults to yesterday (never today).": "lastDayToSyncDefaultsToYesterdayNever",
  "Visits attribution: last, first, lastsign, etc.": "visitsAttributionLastFirstLastsignEtc",
  "Visits fields": "visitsFields",
  "Comma-separated ym:s: fields. Blank = a curated default.": "commaSeparatedYmSFieldsBlankACurated",
  "Hits fields": "hitsFields",
  "Comma-separated ym:pv: fields. Blank = a curated default.": "commaSeparatedYmPvFieldsBlankACurated",
  "Yandex Metrica": "yandexMetrica",
  "Raw hits & visits from the Yandex Metrica Logs API.": "rawHitsVisitsFromTheYandexMetricaLogs",
  "Traffic Overview": "trafficOverview",
  "Daily visits, visitors and engagement for your site. Connect an orders source to see orders and revenue alongside traffic.": "dailyVisitsVisitorsAndEngagementForYourSite",
  "traffic": "traffic",
  "Visits": "visits",
  "Visitors": "visitors",
  "Page Views": "pageViews",
  "New Users": "newUsers",
  "Avg. Visit Duration": "avgVisitDuration",
  "Orders": "orders",
  "Revenue": "revenue",
  "Traffic Sources": "trafficSources",
  "Daily traffic split by acquisition source and device.": "dailyTrafficSplitByAcquisitionSourceAndDevice",
  "Order Attribution": "orderAttribution",
  "Orders and revenue attributed to the traffic source that drove them (last click), with delivery and cancellation splits.": "ordersAndRevenueAttributedToTheTrafficSource",
  "sales": "sales",
  "Delivered Revenue": "deliveredRevenue",
  "Cancelled Orders": "cancelledOrders",
  "Yandex Direct Campaigns": "yandexDirectCampaigns",
  "Daily impressions, clicks, spend, conversions and revenue per Yandex Direct campaign, in each account's currency.": "dailyImpressionsClicksSpendConversionsAndRevenuePer",
  "advertising": "advertising",
  "Impressions": "impressions",
  "Clicks": "clicks",
  "Cost": "cost",
  "Conversions": "conversions",
  "GA4 Traffic Overview": "gA4TrafficOverview",
  "Daily sessions, users, engagement, orders and revenue from your Google Analytics 4 export.": "dailySessionsUsersEngagementOrdersAndRevenueFrom",
  "Sessions": "sessions",
  "Users": "users",
  "Engaged Sessions": "engagedSessions",
  "GA4 Traffic Sources": "gA4TrafficSources",
  "Sessions, engagement and revenue by source, medium, campaign, platform and device, as GA4 attributes each session.": "sessionsEngagementAndRevenueBySourceMediumCampaign",
  "Transactions": "transactions",
  "GA4 Product Funnel": "gA4ProductFunnel",
  "Every item interaction from list views to purchases, with the user, session, page and list it happened in.": "everyItemInteractionFromListViewsToPurchases",
  "Item List Views": "itemListViews",
  "Item Views": "itemViews",
  "Add to Carts": "addToCarts",
  "Items Purchased": "itemsPurchased",
  "Item Revenue": "itemRevenue",
  "GA4 Orders": "gA4Orders",
  "Orders and revenue counted once per transaction, however many times the shop re-sent the purchase, with their items.": "ordersAndRevenueCountedOncePerTransactionHowever",
  "Items Sold": "itemsSold",
  "GA4 Promotions": "gA4Promotions",
  "Views and clicks of internal promotions, and the add-to-carts, orders and revenue that followed them in the session.": "viewsAndClicksOfInternalPromotionsAndThe",
  "Views": "views",
  "Attributed Orders": "attributedOrders",
  "Attributed Revenue": "attributedRevenue",
  "Google Analytics 4 export": "googleAnalytics4Export",
  "Events": "events",
  "Every event the app reported: name, attributes as JSON, session and device.": "everyEventTheAppReportedNameAttributesAs",
  "Event time on the device, yyyy-mm-dd hh:mm:ss.": "eventTimeOnTheDeviceYyyyMmDd",
  "Event name as passed to the SDK.": "eventNameAsPassedToTheSDK",
  "Event attributes serialized as JSON.": "eventAttributesSerializedAsJSON",
  "Time the server received the event, yyyy-mm-dd hh:mm:ss.": "timeTheServerReceivedTheEventYyyyMm",
  "Time the server received the event, Unix seconds.": "timeTheServerReceivedTheEventUnixSeconds",
  "Event time on the device, Unix seconds.": "eventTimeOnTheDeviceUnixSeconds",
  "Session id (64-bit, kept as text).": "sessionId64BitKeptAsText",
  "Installation id.": "installationId",
  "Device id assigned by AppMetrica (64-bit, kept as text).": "deviceIdAssignedByAppMetrica64BitKept",
  "City name in English.": "cityNameInEnglish",
  "Network type: wifi, cell or unknown.": "networkTypeWifiCellOrUnknown",
  "ISO country code.": "iSOCountryCode",
  "Device IP address in IPv6 form at the time of the event.": "deviceIPAddressInIPv6FormAtThe",
  "Device language.": "deviceLanguage",
  "Device manufacturer, e.g. Apple or Samsung.": "deviceManufacturerEGAppleOrSamsung",
  "Device model as AppMetrica names it, e.g. Galaxy S6.": "deviceModelAsAppMetricaNamesItEG",
  "Device type: phone, tablet or unknown.": "deviceTypePhoneTabletOrUnknown",
  "Google advertising id as received from the device.": "googleAdvertisingIdAsReceivedFromTheDevice",
  "iOS advertising id (IDFA) as received from the device.": "iOSAdvertisingIdIDFAAsReceivedFromThe",
  "iOS vendor id (IDFV) for the app.": "iOSVendorIdIDFVForTheApp",
  "Mobile country code.": "mobileCountryCode",
  "Mobile network code.": "mobileNetworkCode",
  "Mobile operator name.": "mobileOperatorName",
  "Factory device model code, e.g. SM-G9550.": "factoryDeviceModelCodeEGSMG9550",
  "Operating system: ios, android or windows.": "operatingSystemIosAndroidOrWindows",
  "Operating system version.": "operatingSystemVersion",
  "User profile id set through the SDK.": "userProfileIdSetThroughTheSDK",
  "Windows advertising id as received from the device.": "windowsAdvertisingIdAsReceivedFromTheDevice",
  "App build number.": "appBuildNumber",
  "Android package name or iOS bundle id.": "androidPackageNameOrIOSBundleId",
  "App version as the developer names it.": "appVersionAsTheDeveloperNamesIt",
  "Numeric id of the app in AppMetrica.": "numericIdOfTheAppInAppMetrica",
  "Installations": "installations",
  "Installs and reinstalls with the attributed click, tracker and partner.": "installsAndReinstallsWithTheAttributedClickTracker",
  "Ad interaction the install is attributed to: click, impression or unknown.": "adInteractionTheInstallIsAttributedToClick",
  "Time of the click or impression.": "timeOfTheClickOrImpression",
  "Id of the click or impression, empty when unknown.": "idOfTheClickOrImpressionEmptyWhen",
  "IP address of the click or impression in IPv6 form.": "iPAddressOfTheClickOrImpressionIn",
  "Time of the click or impression, Unix seconds.": "timeOfTheClickOrImpressionUnixSeconds",
  "Parameters of the tracking URL.": "parametersOfTheTrackingURL",
  "User agent of the click or impression.": "userAgentOfTheClickOrImpression",
  "Id of the AppMetrica publisher (partner).": "idOfTheAppMetricaPublisherPartner",
  "Name of the AppMetrica partner.": "nameOfTheAppMetricaPartner",
  "Name of the tracker in the AppMetrica interface.": "nameOfTheTrackerInTheAppMetricaInterface",
  "Id of the AppMetrica tracker.": "idOfTheAppMetricaTracker",
  "Installation time on the device.": "installationTimeOnTheDevice",
  "IP address at installation time in IPv6 form.": "iPAddressAtInstallationTimeInIPv6Form",
  "Time the server received the install, yyyy-mm-dd hh:mm:ss.": "timeTheServerReceivedTheInstallYyyyMm",
  "Time the server received the install, Unix seconds.": "timeTheServerReceivedTheInstallUnixSeconds",
  "Installation time on the device, Unix seconds.": "installationTimeOnTheDeviceUnixSeconds",
  "Whether the install was reattributed to a new source.": "whetherTheInstallWasReattributedToANew",
  "Whether the app was reinstalled.": "whetherTheAppWasReinstalled",
  "Attribution method: fingerprint, referrer, identifier or empty.": "attributionMethodFingerprintReferrerIdentifierOrEmpty",
  "Fingerprint attribution method: unknown, fingerprint, ctv or desktop.": "fingerprintAttributionMethodUnknownFingerprintCtvOrDesktop",
  "Huawei OAID as received from the device.": "huaweiOAIDAsReceivedFromTheDevice",
  "Session starts": "sessionStarts",
  "One row per session start with the device and app that opened it.": "oneRowPerSessionStartWithTheDevice",
  "Session start time on the device.": "sessionStartTimeOnTheDevice",
  "Time the server received the session start.": "timeTheServerReceivedTheSessionStart",
  "Time the server received the session start, Unix seconds.": "timeTheServerReceivedTheSessionStartUnix",
  "Session start time on the device, Unix seconds.": "sessionStartTimeOnTheDeviceUnixSeconds",
  "Crashes": "crashes",
  "App crashes with the stack trace, the crash group and the device.": "appCrashesWithTheStackTraceTheCrash",
  "Stack trace.": "stackTrace",
  "Crash time on the device.": "crashTimeOnTheDevice",
  "Id of the group of similar crashes.": "idOfTheGroupOfSimilarCrashes",
  "Crash id.": "crashId",
  "Crash parameters as JSON.": "crashParametersAsJSON",
  "Crash name.": "crashName",
  "Time the server received the crash.": "timeTheServerReceivedTheCrash",
  "Time the server received the crash, Unix seconds.": "timeTheServerReceivedTheCrashUnixSeconds",
  "Crash time on the device, Unix seconds.": "crashTimeOnTheDeviceUnixSeconds",
  "Errors": "errors",
  "Errors the app reported through the SDK, with their parameters.": "errorsTheAppReportedThroughTheSDKWith",
  "Error text.": "errorText",
  "Error time on the device.": "errorTimeOnTheDevice",
  "Error id.": "errorId",
  "Error parameters as JSON.": "errorParametersAsJSON",
  "Error name.": "errorName",
  "Time the server received the error.": "timeTheServerReceivedTheError",
  "Time the server received the error, Unix seconds.": "timeTheServerReceivedTheErrorUnixSeconds",
  "Error time on the device, Unix seconds.": "errorTimeOnTheDeviceUnixSeconds",
  "In-app purchases: product, price, currency, order and verification.": "inAppPurchasesProductPriceCurrencyOrderAnd",
  "Number of products bought.": "numberOfProductsBought",
  "Price; negative for a refund.": "priceNegativeForARefund",
  "Currency code, ISO 4217.": "currencyCodeISO4217",
  "Product id.": "productId",
  "Order id.": "orderId",
  "Where the order id came from: autogenerated or user_defined.": "whereTheOrderIdCameFromAutogeneratedOr",
  "Purchase verification: true, false or undefined.": "purchaseVerificationTrueFalseOrUndefined",
  "Android id as received from the device.": "androidIdAsReceivedFromTheDevice",
  "AppMetrica SDK version.": "appMetricaSDKVersion",
  "E-commerce": "eCommerce",
  "Shop funnel events: screens, product cards, cart changes and purchases.": "shopFunnelEventsScreensProductCardsCartChanges",
  "Event type: show_screen, show_product_card, show_product_details, add_cart_item, remove_cart_item, begin_checkout or purchase.": "eventTypeShowScreenShowProductCardShow",
  "Screen name.": "screenName",
  "Search query on the screen.": "searchQueryOnTheScreen",
  "Screen parameters as JSON.": "screenParametersAsJSON",
  "Screen category, level 1.": "screenCategoryLevel1",
  "Screen category, level 2.": "screenCategoryLevel2",
  "Screen category, level 3.": "screenCategoryLevel3",
  "Screen category, level 4.": "screenCategoryLevel4",
  "Screen category, level 5.": "screenCategoryLevel5",
  "Screen category, level 6.": "screenCategoryLevel6",
  "Screen category, level 7.": "screenCategoryLevel7",
  "Screen category, level 8.": "screenCategoryLevel8",
  "Screen category, level 9.": "screenCategoryLevel9",
  "Screen category, level 10.": "screenCategoryLevel10",
  "Product name.": "productName",
  "Product id (SKU).": "productIdSKU",
  "Promo codes as a JSON array.": "promoCodesAsAJSONArray",
  "Product parameters as JSON.": "productParametersAsJSON",
  "Product category, level 1.": "productCategoryLevel1",
  "Product category, level 2.": "productCategoryLevel2",
  "Product category, level 3.": "productCategoryLevel3",
  "Product category, level 4.": "productCategoryLevel4",
  "Product category, level 5.": "productCategoryLevel5",
  "Product category, level 6.": "productCategoryLevel6",
  "Product category, level 7.": "productCategoryLevel7",
  "Product category, level 8.": "productCategoryLevel8",
  "Product category, level 9.": "productCategoryLevel9",
  "Product category, level 10.": "productCategoryLevel10",
  "Currency of the actual product price.": "currencyOfTheActualProductPrice",
  "Actual product price.": "actualProductPrice",
  "Components of the actual price as a JSON array.": "componentsOfTheActualPriceAsAJSON",
  "Currency of the base product price.": "currencyOfTheBaseProductPrice",
  "Base product price.": "baseProductPrice",
  "Components of the base price as a JSON array.": "componentsOfTheBasePriceAsAJSON",
  "Currency of the cart item price.": "currencyOfTheCartItemPrice",
  "Cart item price.": "cartItemPrice",
  "Number of items in the cart line.": "numberOfItemsInTheCartLine",
  "Components of the cart item price as a JSON array.": "componentsOfTheCartItemPriceAsA",
  "Type of the traffic source.": "typeOfTheTrafficSource",
  "Id of the traffic source.": "idOfTheTrafficSource",
  "Purchase id.": "purchaseId",
  "Purchase parameters as JSON.": "purchaseParametersAsJSON",
  "Push tokens": "pushTokens",
  "Push tokens registered by devices, with when each was created.": "pushTokensRegisteredByDevicesWithWhenEach",
  "Push token.": "pushToken",
  "Token creation time on the device.": "tokenCreationTimeOnTheDevice",
  "Time the server received the token.": "timeTheServerReceivedTheToken",
  "Time the server received the token, Unix seconds.": "timeTheServerReceivedTheTokenUnixSeconds",
  "Token creation time, Unix seconds.": "tokenCreationTimeUnixSeconds",
  "Clicks and impressions": "clicksAndImpressions",
  "Ad clicks and impressions registered by trackers, attributed or not.": "adClicksAndImpressionsRegisteredByTrackersAttributed",
  "click, impression or unknown.": "clickImpressionOrUnknown",
  "Whether the click came from outside a browser.": "whetherTheClickCameFromOutsideABrowser",
  "Postbacks": "postbacks",
  "Postbacks sent to partners: the conversion, the attempt and its outcome.": "postbacksSentToPartnersTheConversionTheAttempt",
  "Time of the event, install or re-engagement the postback reports.": "timeOfTheEventInstallOrReEngagement",
  "Conversion time, Unix seconds.": "conversionTimeUnixSeconds",
  "Time the postback was sent.": "timeThePostbackWasSent",
  "Time the postback was sent, Unix seconds.": "timeThePostbackWasSentUnixSeconds",
  "Postback type: cpi (install), cpa (event) or cpr (re-engagement).": "postbackTypeCpiInstallCpaEventOrCpr",
  "Sending status: sent or failed.": "sendingStatusSentOrFailed",
  "Postback URL.": "postbackURL",
  "Postback URL parameters.": "postbackURLParameters",
  "Response body from the partner.": "responseBodyFromThePartner",
  "HTTP status of the partner's response.": "hTTPStatusOfThePartnerSResponse",
  "Deeplinks": "deeplinks",
  "App opens through deeplinks, with the link and the tracker behind it.": "appOpensThroughDeeplinksWithTheLinkAnd",
  "Deeplink host.": "deeplinkHost",
  "Deeplink parameters.": "deeplinkParameters",
  "Deeplink path.": "deeplinkPath",
  "Deeplink URL scheme.": "deeplinkURLScheme",
  "Whether the tracker belongs to a remarketing campaign.": "whetherTheTrackerBelongsToARemarketingCampaign",
  "Ad revenue": "adRevenue",
  "Revenue from ads shown in the app: network, placement, unit and amount.": "revenueFromAdsShownInTheAppNetwork",
  "Event time on the device.": "eventTimeOnTheDevice",
  "Time the server received the event.": "timeTheServerReceivedTheEvent",
  "Revenue amount.": "revenueAmount",
  "Currency of the revenue.": "currencyOfTheRevenue",
  "Ad type: native, banner, rewarded, interstitial, mrec or other.": "adTypeNativeBannerRewardedInterstitialMrecOr",
  "How the revenue was collected: autocollected or manual.": "howTheRevenueWasCollectedAutocollectedOrManual",
  "Ad network.": "adNetwork",
  "Ad placement id.": "adPlacementId",
  "Ad placement name.": "adPlacementName",
  "Ad unit id.": "adUnitId",
  "Ad unit name.": "adUnitName",
  "Precision of the amount, e.g. publisher_defined or estimated.": "precisionOfTheAmountEGPublisherDefined",
  "Extra parameters as JSON.": "extraParametersAsJSON",
  "Campaigns by day": "campaignsByDay",
  "Spend, impressions, clicks, conversions and revenue per campaign, day, network (search / ad network) and device. Always loaded: the standard reports are built on it.": "spendImpressionsClicksConversionsAndRevenuePerCampaign",
  "Ad groups by day": "adGroupsByDay",
  "The same metrics per ad group, day, network and device.": "theSameMetricsPerAdGroupDayNetwork",
  "Ads by day": "adsByDay",
  "The same metrics per ad, day, network, device and ad format.": "theSameMetricsPerAdDayNetworkDevice",
  "Keywords and targeting by day": "keywordsAndTargetingByDay",
  "Per keyword, autotargeting or audience condition, match type, day, network and device.": "perKeywordAutotargetingOrAudienceConditionMatchType",
  "Search queries by day": "searchQueriesByDay",
  "The search queries ads were shown on, per ad group, ad and keyword. Direct keeps queries for 180 days only.": "theSearchQueriesAdsWereShownOnPer",
  "Placements by day": "placementsByDay",
  "Per site or app of the ad network and external network (SSP), per campaign and day.": "perSiteOrAppOfTheAdNetwork",
  "Gender and age by day": "genderAndAgeByDay",
  "Per gender, age group, device and network, per campaign and day.": "perGenderAgeGroupDeviceAndNetworkPer",
  "Regions by day": "regionsByDay",
  "Per region where the user was and region that was targeted, per campaign and day.": "perRegionWhereTheUserWasAndRegion",
  "Ad positions by day": "adPositionsByDay",
  "Per ad block on the results page, per campaign, device and day.": "perAdBlockOnTheResultsPagePer",
  "Click types by day": "clickTypesByDay",
  "Which part of the ad was clicked (title, sitelink, phone, …), per campaign and day. Without impressions: Direct does not report them by click type.": "whichPartOfTheAdWasClickedTitle",
  "Mobile platforms and carriers by day": "mobilePlatformsAndCarriersByDay",
  "Per operating system and connection type, per campaign, device and day.": "perOperatingSystemAndConnectionTypePerCampaign",
  "Income groups by day": "incomeGroupsByDay",
  "Per income group of the audience, per campaign, device and day.": "perIncomeGroupOfTheAudiencePerCampaign",
  "Reach and frequency by day": "reachAndFrequencyByDay",
  "Media campaigns only: reach, frequency and video views per campaign, ad group, ad, device and day.": "mediaCampaignsOnlyReachFrequencyAndVideoViews",
  "Conversions by goal by day": "conversionsByGoalByDay",
  "Conversions and revenue per Metrica goal, campaign, network, device and day — one row per goal. Goals are the campaigns' key goals plus any listed in the connection.": "conversionsAndRevenuePerMetricaGoalCampaignNetwork",
  "Clients": "clients",
  "The connected advertisers: currency, VAT rate, limits, settings.": "theConnectedAdvertisersCurrencyVATRateLimitsSettings",
  "Campaigns": "campaigns",
  "Every campaign with its settings, strategy, budget and status.": "everyCampaignWithItsSettingsStrategyBudgetAnd",
  "Ad groups": "adGroups",
  "Every ad group with its regions, settings and status.": "everyAdGroupWithItsRegionsSettingsAnd",
  "Ads": "ads",
  "Every ad with its texts, links, images and status.": "everyAdWithItsTextsLinksImagesAnd",
  "Keywords": "keywords",
  "Every keyword and autotargeting with bids, status and Direct's forecast figures.": "everyKeywordAndAutotargetingWithBidsStatusAnd",
  "+3 points per 2,000 keywords": "3PointsPer2000Keywords",
  "Bids": "bids",
  "Search and network bids per keyword with the auction figures.": "searchAndNetworkBidsPerKeywordWithThe",
  "Keyword bids": "keywordBids",
  "Bids per keyword and autotargeting with the auction figures.": "bidsPerKeywordAndAutotargetingWithTheAuction",
  "Bid adjustments": "bidAdjustments",
  "Bid adjustments per campaign and ad group.": "bidAdjustmentsPerCampaignAndAdGroup",
  "Audience targets": "audienceTargets",
  "Audience targeting conditions per ad group.": "audienceTargetingConditionsPerAdGroup",
  "Retargeting lists": "retargetingLists",
  "Retargeting and audience conditions.": "retargetingAndAudienceConditions",
  "Callouts": "callouts",
  "Callout extensions.": "calloutExtensions",
  "Sitelinks": "sitelinks",
  "Sitelink sets.": "sitelinkSets",
  "Business cards": "businessCards",
  "Business cards of ads.": "businessCardsOfAds",
  "Images": "images",
  "Ad images.": "adImages",
  "Creatives": "creatives",
  "Video, HTML5 and smart-banner creatives.": "videoHTML5AndSmartBannerCreatives",
  "Feeds": "feeds",
  "Product feeds.": "productFeeds",
  "Portfolio strategies": "portfolioStrategies",
  "Shared bidding strategies.": "sharedBiddingStrategies",
  "not in Direct's points table; an estimate": "notInDirectSPointsTableAnEstimate",
  "Negative keyword sets": "negativeKeywordSets",
  "Shared negative keyword sets.": "sharedNegativeKeywordSets",
  "Turbo pages": "turboPages",
  "Turbo pages.": "turboPages2",
  "Businesses": "businesses",
  "Organizations from Yandex Business linked to the account.": "organizationsFromYandexBusinessLinkedToTheAccount",
  "Dynamic ad targets": "dynamicAdTargets",
  "Webpage conditions of dynamic ads.": "webpageConditionsOfDynamicAds",
  "Feed filters": "feedFilters",
  "Feed filters of dynamic ads.": "feedFiltersOfDynamicAds",
  "Smart banner filters": "smartBannerFilters",
  "Filters of smart banners.": "filtersOfSmartBanners",
  "Regions": "regions",
  "Direct reference data: regions.": "directReferenceDataRegions",
  "Region names": "regionNames",
  "Direct reference data: region names.": "directReferenceDataRegionNames",
  "Currencies": "currencies",
  "Direct reference data: currencies.": "directReferenceDataCurrencies",
  "Time zones": "timeZones",
  "Direct reference data: time zones.": "directReferenceDataTimeZones",
  "Constants": "constants",
  "Direct reference data: constants.": "directReferenceDataConstants",
  "Metro stations": "metroStations",
  "Direct reference data: metro stations.": "directReferenceDataMetroStations",
  "Ad categories": "adCategories",
  "Direct reference data: ad categories.": "directReferenceDataAdCategories",
  "Operating system versions": "operatingSystemVersions",
  "Direct reference data: operating system versions.": "directReferenceDataOperatingSystemVersions",
  "Productivity recommendations": "productivityRecommendations",
  "Direct reference data: productivity recommendations.": "directReferenceDataProductivityRecommendations",
  "External networks (SSP)": "externalNetworksSSP",
  "Direct reference data: external networks (ssp).": "directReferenceDataExternalNetworksSsp",
  "Mobile app interests": "mobileAppInterests",
  "Direct reference data: mobile app interests.": "directReferenceDataMobileAppInterests",
  "Audience criteria types": "audienceCriteriaTypes",
  "Direct reference data: audience criteria types.": "directReferenceDataAudienceCriteriaTypes",
  "Audience demographic profiles": "audienceDemographicProfiles",
  "Direct reference data: audience demographic profiles.": "directReferenceDataAudienceDemographicProfiles",
  "Audience interests": "audienceInterests",
  "Direct reference data: audience interests.": "directReferenceDataAudienceInterests",
  "Feed filter schemas": "feedFilterSchemas",
  "Direct reference data: feed filter schemas.": "directReferenceDataFeedFilterSchemas",
  "database": "databases",
  "analytics": "analytics",
  "crm": "cRM",
  "ecommerce": "eCommerce2",
  "marketplace": "marketplaces",
  "other": "other",
  "saas": "saaS",
  "file": "fileObjectStorage",
  "streaming": "streaming",
  "custom": "customPrivateRepo",
  "metrika_counter": "counter",
  "appmetrica_application": "application"
};

const BUILTIN_CONNECTORS = new Set(["bigquery", "google-analytics-4", "google-sheets", "http-api", "hubspot", "kafka", "mongodb", "mssql", "mysql", "ozon", "ozon-performance", "postgres", "s3", "s3-files", "salesforce", "shopify", "snowflake", "stripe", "topvisor", "yandex-appmetrica", "yandex-appmetrica-datastream", "yandex-direct", "yandex-metrica"]);
const STANDARD_REPORTS = new Set([
  "traffic-overview", "traffic-sources", "order-attribution", "direct-campaigns",
  "ga4-traffic-overview", "ga4-traffic-sources", "ga4-products", "ga4-orders", "ga4-promotions",
]);

export function translateMetadata(value) {
  return typeof value === 'string' && Object.hasOwn(METADATA_KEYS, value)
    ? t(`metadata.${METADATA_KEYS[value]}`) : value;
}

/** Translate display annotations only; values, defaults and schema constraints stay exact. */
export function localizeSchema(schema) {
  if (!schema || typeof schema !== 'object' || Array.isArray(schema)) return schema;
  const result = { ...schema };
  for (const field of ['title', 'description']) {
    if (typeof schema[field] === 'string') result[field] = translateMetadata(schema[field]);
  }
  if (Array.isArray(schema.enumNames)) result.enumNames = schema.enumNames.map(translateMetadata);
  for (const keyword of ['properties', 'patternProperties', '$defs', 'definitions', 'dependentSchemas']) {
    if (schema[keyword] && typeof schema[keyword] === 'object') {
      result[keyword] = Object.fromEntries(Object.entries(schema[keyword]).map(([key, value]) => [key, localizeSchema(value)]));
    }
  }
  for (const keyword of ['items', 'additionalProperties', 'additionalItems', 'contains', 'not', 'if', 'then', 'else', 'propertyNames', 'unevaluatedItems', 'unevaluatedProperties']) {
    if (schema[keyword] && typeof schema[keyword] === 'object') {
      result[keyword] = Array.isArray(schema[keyword]) ? schema[keyword].map(localizeSchema) : localizeSchema(schema[keyword]);
    }
  }
  for (const keyword of ['allOf', 'anyOf', 'oneOf', 'prefixItems']) {
    if (Array.isArray(schema[keyword])) result[keyword] = schema[keyword].map(localizeSchema);
  }
  return result;
}

export const isBuiltinConnectorType = (type) => Boolean(type && type.is_custom === false && BUILTIN_CONNECTORS.has(type.slug));

/** API payloads/cache entries remain unchanged; only confirmed built-in UI metadata is copied. */
export function localizeConnectorType(type) {
  if (!isBuiltinConnectorType(type)) return type;
  return {
    ...type,
    name: translateMetadata(type.name),
    description: translateMetadata(type.description),
    category_label: translateMetadata(type.category),
    ...(type.config_schema ? { config_schema: localizeSchema(type.config_schema) } : {}),
  };
}

// Source ownership is explicit because a tenant's connector can shadow a
// platform connector's slug even in a standard report.
function localizeSource(source) {
  if (!source || source.is_custom !== false) return source;
  return {
    ...source,
    name: translateMetadata(source.name),
    ...(typeof source.description === 'string' ? { description: translateMetadata(source.description) } : {}),
  };
}

export function localizeReport(report) {
  if (!report || report.is_custom !== false || !STANDARD_REPORTS.has(report.slug)) return report;
  return {
    ...report,
    name: translateMetadata(report.name),
    description: translateMetadata(report.description),
    category_label: translateMetadata(report.category),
    ...(Array.isArray(report.missing_sources) ? { missing_sources: report.missing_sources.map(localizeSource) } : {}),
    ...(Array.isArray(report.metrics) ? { metrics: report.metrics.map((metric) => metric.is_custom ? metric : ({
      ...metric,
      name: translateMetadata(metric.name),
      ...(Array.isArray(metric.missing_sources) ? { missing_sources: metric.missing_sources.map(localizeSource) } : {}),
      ...(typeof metric.description === 'string' ? { description: translateMetadata(metric.description) } : {}),
    })) } : {}),
  };
}
